import React, {useEffect, useState} from 'react';
import {PanelWrapper} from "../../../components";
import {SortByItem, SortByLists, SortTitle} from "../../../core-ui/sort-list/sort-list";
import {Card, CardAction} from "../../../core-ui/card/card";
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {ShapeEndTimm, ShapeStartTimm} from "../../../core-ui/shapes/shapes";
import {fetchData, separatePriceFormat} from "../../../helpers/general-function";
import moment from "moment-jalaali";
import MobileSort from "../../../components/mobile-sort/mobile-sort";
import {CustomSheet, MobileSortItem} from "../../../components/mobile-sort-item/mobile-sort-item.styles";
import Sheet from "react-modal-sheet";

const SHIFT_ORDERS = [
    {name: 'درخواست های باز', order: 'pending'},
    {name: 'درخواست های انجام شده', order: 'completed'},
    {name: 'درخواست های انجام نشده', order: 'canceled'},
    {name: 'همه درخواست ها', order: 'all'},
];

const MyRequests = () => {

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const [requests, setRequests] = useState([]);
    const [activeOrder, setActiveOrder] = useState('pending');
    const [mobileSortModal, setMobileSortModal] = useState(false);

    useEffect(() => {
        (async () => {
            const order = searchParams.get('order');

            if (!order) {
                navigate('/panel/my-requests?order=pending');
                return false;
            }

            const data = await fetchData('panel/shift-times', 'get', {offset: '0', limit: '10', order}, true);

            if (data) {
                setRequests(data.shift_times);
                setActiveOrder(order);
                if(mobileSortModal) {
                    setMobileSortModal(false)
                }
            }
        })()

    }, [searchParams]);

    return (
        <>
            <PanelWrapper activeRouteData={{icon: 'icon-people', name: 'درخواست‌های من'}}>
                <MobileSort clickHandler={() => setMobileSortModal(true)}
                            itemClassName='px-0'
                            title='فیلتر کردن بر اساس:'
                            sortName={SHIFT_ORDERS.find(item => item.order === activeOrder).name}/>

                <div className='d-none d-lg-flex'>
                    <div className='d-flex align-items-center'>
                        <i className='icon-document-filter ms-2'/>
                        <SortTitle className='mb-0 dark-gray'>فیلتر کردن بر اساس:</SortTitle>
                        <SortByLists>
                            {
                                SHIFT_ORDERS.map((item, index) => (
                                    <SortByItem className={item.order === activeOrder ? 'active-sort' : ''} key={index}>
                                        <Link to={`/panel/my-requests?order=${item.order}`}>{item.name}</Link>
                                    </SortByItem>
                                ))
                            }
                        </SortByLists>
                    </div>
                </div>
                <div className='mt-5'>
                    <div className='row'>
                        {
                            requests.map(item => (
                                <div className='col-12 col-md-6' key={item.id}>
                                    <Card>
                                        <p><i className='icon-hospital align-middle ms-2'/>{item.shift.pharmacy.name}
                                        </p>
                                        <p><i className='icon-location align-middle ms-2'/>{item.shift.pharmacy.address}
                                        </p>
                                        <p className='mt-c-2'><i
                                            className='icon-dollar-square align-middle ms-2 icon-success'/>حق الزحمه
                                            شیفت: {separatePriceFormat(item.earning)}</p>
                                        <p><i className='icon-calendar align-middle ms-2 icon-success'/>تاریخ پرداخت
                                            حق‌الزحمه: {`${moment(item.settlement_date, 'YYYY-MM-DD').format('dddd jYYYY/jMM/jDD')}`}
                                        </p>
                                        <div className='mt-c-2 d-flex'>
                                            <div className='d-flex flex-column justify-content-between my-1 ms-2'>
                                                <ShapeStartTimm/>
                                                <div className='bottom-dashed-vertical flex-grow-1 ms-2'/>
                                                <ShapeEndTimm/>
                                            </div>
                                            <div>
                                                <p>{`${moment(item.from, 'YYYY-MM-DD HH:mm:ss').format('از dddd jYYYY/jMM/jDD ساعت HH:mm:ss')}`}</p>
                                                <p className='mb-0'>{`${moment(item.to, 'YYYY-MM-DD HH:mm:ss').format('تا dddd jYYYY/jMM/jDD ساعت HH:mm:ss')}`}</p>
                                            </div>
                                        </div>
                                        <div className='mb-c-2_5 mt-c-2_5 mb-lg-0 mt-lg-4 me-2 me-lg-0 text-end text-lg-center'>
                                            {
                                                item.user_has_requested === 0 ?
                                                    <p className='success-color'>هنوز کسی اعلام آمادگی نکرده است</p>
                                                    :
                                                    <Link to={`/panel/my-request-single/${item.id}`}
                                                          className='accent-success-color'>
                                                        <i className='icon-warning align-middle d-inline-block ms-2'/>
                                                        <span>{item.shift_requests_count} نفر اعلام آمادگی کرده اند</span>
                                                    </Link>
                                            }

                                        </div>
                                        <CardAction>
                                            <div>
                                                <Link to={`/panel/my-request-single/${item.id}`} className='sky-color'>مشاهده
                                                    درخواست</Link>
                                            </div>
                                            <div>
                                                <Link to={`/panel/edit-request/${item.id}`} className='danger-color'>ویرایش
                                                    درخواست</Link>
                                            </div>
                                        </CardAction>
                                    </Card>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </PanelWrapper>

            <CustomSheet isOpen={mobileSortModal} onClose={() => setMobileSortModal(false)}
                         snapPoints={[.7, 0.5, 100, 0]}>
                <Sheet.Container>
                    <Sheet.Header>
                        <div className='d-flex align-items-center justify-content-center px-2 py-3 rtl'>
                            <button className='btn-text ms-auto pt-2' onClick={() => setMobileSortModal(false)}>
                                <i className='icon-close-circle' />
                            </button>
                            <p className='dark-gray mb-0 flex-grow-1 text-center ms-5'>فیلتر کردن بر اساس</p>
                        </div>
                    </Sheet.Header>

                    <Sheet.Content>
                        <ul className='l-s-t-none mt-3 mb-0 p-0'>
                            {
                                SHIFT_ORDERS.map((item, index) => (
                                    <MobileSortItem className={activeOrder === item.order ? 'active-sort' : ''} key={index}>
                                        <Link to={`/panel/my-requests?order=${item.order}`}>{item.name}</Link>
                                        {
                                            activeOrder === item.order &&
                                            <i className='icon-tick-circle tick' />
                                        }
                                    </MobileSortItem>
                                ))
                            }
                        </ul>
                    </Sheet.Content>
                </Sheet.Container>

                <Sheet.Backdrop />
            </CustomSheet>
        </>
    );
};

export default MyRequests;
